<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings/pos-settings"></ion-back-button>
    </ion-buttons>
    <ion-title>Currency</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf='isLoading'></salonmonster-load-mask>

  <salonmonster-tap-retry *ngIf="errorOccured" (click)="loadCurrencies()"></salonmonster-tap-retry>

  <ng-container *ngIf="!isLoading && !errorOccured">
    <ion-row>
      <ion-col class="hidden-sm-down"></ion-col>

      <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">

          <ion-item>
            <ion-label>What currency do you use?</ion-label>
            <ion-select [(ngModel)]="currencyPicker">
              <ion-select-option *ngFor="let currency of currencies" [value]="currency.id">
                {{ currency.symbol }}
              </ion-select-option>
            </ion-select>
          </ion-item>
          <div class="ion-text-wrap ion-padding">
            <ion-note>Are we missing your currency? Contact us and we'll add it right away.</ion-note>
          </div>
          <br/>
          <ion-button 
            class="ion-no-margin" 
            expand="block"
            class="hidden-sm-down" 
            (click)="save()">
            Save
          </ion-button>
      </ion-col>
      
      <ion-col class="hidden-sm-down"></ion-col>
    </ion-row>
  </ng-container>
</ion-content>

<ion-footer class="ion-no-margin" class="hidden-md-up" *ngIf="!isLoading && !errorOccured">
  <ion-toolbar class="ion-no-margin ion-no-padding">
    <ion-button 
      class="ion-no-margin"
      expand="block" 
       
      (click)="save()">
      Save
    </ion-button>
  </ion-toolbar>
</ion-footer>